<template>
  <div
      class="d-flex align-items-start mb-3 message-left">
    <font-awesome-icon
        class="user-icon-left mx-2"
        :icon="['fas', 'user-circle']"
        style="align-self: flex-end;"
    />
    <div>
      <div class="check-flex">
      <div class="user-name" style="color: #374154; font-weight: 600; font-size: 14px;">
        {{ message.user }}
      </div>
      <div class="user-name" style="color: gray; font-size: 12px; margin-top: 4px;">
        {{ formatDate(message.creationDate) }}
      </div>
    </div>
      <div v-if="message.message" class="message-content">
        {{ message.message }}
      </div>
      <div class="check-flex"></div>
    </div>
  </div>

</template>


<script>
import SimpleActivity from "@/activity/templates/layouts/SimpleActivity.vue";
import Activity from "@/activity/Activity";
import Rpc from "@/Rpc";
import FormsLoader from "@/components/forms/FormsLoader";
import OrderDetails from "@/server/com/silkplm/model/plm/OrderDetails";
import ChatMessageBase from "@/server/com/silkplm/model/plm/chat/ChatMessageBase";
import ChatMessageInquiry from "@/server/com/silkplm/model/plm/chat/ChatMessageInquiry";
import TemporaryList from "@/components/forms/TemporaryList";
import ComplexActivity from "@/activity/templates/layouts/ComplexActivity.vue";
import FooterButton from "@/components/navbar/FooterButton.vue";
import FooterNavbar from "@/components/navbar/FooterNavbar.vue";
import tr from "@/utils/Tr";
import DashletsRpc from "@/DashletsRpc";
import UnreadMessages from "@/components/dashlets/UnreadMessages.vue";
import Attachment from "@/server/com/silkplm/xorg/Attachment";
import AttachmentsData from "@/server/com/silkplm/xorg/AttachmentsData";
import FormHeader from "@/components/forms/FormHeader.vue";

export default {
  name: "MessageLeft",
  components: {},

  mounted() {

  },

  props: {
    message: null,
    formatDate: Function
  },


  methods: {
    tr,
    ...Activity.methods,
  },



  data() {
    return {
    }
  },


}
</script>

<style scoped>
.user-name {
  margin-top: 2px;
  max-width: 100%;
  white-space: nowrap;
}

.message-content {
  padding: 10px;
  word-wrap: break-word;
  box-sizing: border-box;
  display: inline-block;
  word-break: break-word;
}

.message-left .message-content {
  background-color: #e4e8f0;
  text-align: left;
  border-radius: 8px 8px 8px 8px;
}

.message-icon-bottom {
  text-align: right;
  margin-top: 4px;
}

.message-status-icon {
  color: gray;
  font-size: 14px;
}

.message-left {
  max-width: 75%;
}

.check-flex {
  display: flex;
  gap: 10px;
}

.user-icon-left {
  font-size: 40px;
  color: #98a3b7;
}


@media screen and (max-width: 500px) {
  .user-icon-left {
    display: none;
  }
}

@media screen and (max-width: 400px) {
  .check-flex {
    flex-direction: column;
    gap: 0;
  }
}


</style>